<template>
  <q-dialog v-model="shown">
    <q-card
      :style="{ 'width': '450px', 'max-width': '95%' }"
      @keyup.enter="emitOrderItem"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section
          class="text-h5"
        >
          Add Miscellaneous Item
        </q-card-section>

        <q-card-section
          v-if="orderItem"
        >
          <div class="row items-center q-col-gutter-sm">
            <q-input
              ref="orderItemDescription"
              v-model.trim="orderItem.description"
              class="col-6"
              label="Description"
              :rules="[
                val => val !== null && val !== '' || 'Cannot be blank'
              ]"
              focus
            />
            <q-input
              ref="miscAmount"
              v-model.number="orderItem.amount"
              class="col-6"
              label="Amount"
              :prefix="currentCircuit.localeCurrencySymbol"
              type="number"
              step="0.01"
              :rules="[
                val => val !== 0 || 'Cannot be zero',
                val => val !== null && val !== '' || 'Cannot be blank'
              ]"
            />
          </div>
          <div
            class="row items-center q-col-gutter-sm"
          >
            <q-checkbox
              v-model="orderItem.taxable"
              :disable="forceTax"
              class="col-4 q-pb-md"
              :label="$t('pricing.taxable')"
              bottom-slots
            />
            <q-select
              v-if="orderItem.taxable"
              v-model="orderItem.taxIds"
              class="col-8"
              :label="$t('pricing.tax')"
              stack-label
              :options="taxes.data"
              option-value="id"
              map-options
              emit-value
              multiple
              clearable
              :rules="[val => (!!val && val.length > 0) || $t('form.errors.required')]"
              bottom-slots
            >
              <template #selected-item="scope">
                <q-chip
                  v-if="scope.opt.name"
                  removable
                  dense
                  :tabindex="scope.tabindex"
                  :label="scope.opt.name"
                  @remove="scope.removeAtIndex(scope.index)"
                />
              </template>
              <template #option="scope">
                <q-item
                  v-bind="scope.itemProps"
                  v-on="scope.itemEvents"
                >
                  <q-item-section>
                    {{ scope.opt.name }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
          <div
            class="row items-center q-col-gutter-sm"
          >
            <q-checkbox
              v-model="orderItem.print"
              class="col-6 q-pb-md"
              label="Print"
              bottom-slots
              @update:model-value="value => orderItem.itemSourceLocationId = value ? orderItem.defaultItemSourceLocationId : null"
            />
            <q-select
              v-if="orderItem.print"
              v-model="orderItem.itemSourceLocationId"
              class="col-6"
              label="Print Location"
              :options="locations.data"
              option-label="name"
              option-value="id"
              map-options
              emit-value
              bottom-slots
              dense
              @update:model-value="value => orderItem.defaultItemSourceLocationId = value"
            />
          </div>
        </q-card-section>

        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            v-close-popup
            label="Cancel"
            :outline="true"
          />
          <q-btn

            label="Add Item"
            color="primary"
            @click="emitOrderItem"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'RegisterButtonMiscItemDialog',
  mixins: [FormValidationMixin],
  configuration: ['currentCircuit', 'taxes', 'locations'],
  emits: ['update-misc-item'],
  data () {
    return {
      shown: false,
      orderItem: null,
      forceTax: false,
      // We are forced to have this as orderItem.tax is computed off orderItem.data.tax,
      // and data.tax is impossible to make reactive
      taxKeyIterator: 0
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.orderItem = null
        this.forceTax = false
      }
    }
  },
  methods: {
    async show (orderItem, forceTax = false) {
      this.orderItem = orderItem
      this.forceTax = !!orderItem.tax && forceTax // Only force tax if the item has a tax to force

      this.shown = true

      await this.$nextTick() // Wait for elements to be rendered
      this.$refs.orderItemDescription.select()
    },
    emitOrderItem () {
      this.validateForm(() => {
        this.$emit('update-misc-item', this.orderItem)
        this.shown = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  flex-wrap: wrap;
}
.button {
  padding: 10px;
  height: 100%;
}
</style>
